import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Slide,
  Switch,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import CircularLoader from "../../../components/loading/circularLoader";
import Btn from "../../../components/buttons/Btn";
import { FontButton } from "../../financeiro/nfe/styles/Emissao";
import {
  RevisaoContratoContext,
  RevisaoContratoContextProvider,
} from "./contexts/RevisaoContratoContext";
import useRevisaoContratoController from "./controllers/RevisaoContratoController";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import SelectErp from "../../../components/basics/SelectErp";
import {
  CustomContainer,
  FinishContainer,
  FinishIcon,
  FinishText,
  StyledChip,
} from "./styles/RevisaoContrato";
import Loading from "../../../components/basics/Loading";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import MaskService from "../../../utils/mask/maskService";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import HelperTooltip from "../../../components/basics/HelperTooltip";
import TableDefault from "../../../components/grid/TableDefault";
import { findClientsContractsResumeV3 } from "../../../repositories/qerpapi/v3/faturamento/ContratoRepository";

const View = () => {
  const {
    clientList,
    setClientList,
    isSelectingClients,
    currentClientIndex,
    direction,
    displayContent,
    setDisplayContent,
    viewLoading,
    finishScreen,
    currentContractIndex,
    customMessage,
    disabledButton,
    allSelected,
    setAllSelected,
    urlObjects,
    setUrlObjects,
    clickResponseTotal,
  } = useContext(RevisaoContratoContext);

  const { queryParams } = useContext(QueryParamsContext);

  const {
    getData,
    handleClose,
    handleClickBack,
    handleClickNext,
    handleClickReset,
    handleFinishSelecting,
    handleManagement,
  } = useRevisaoContratoController();

  const [loading, setLoading] = useState(false);

  // useEffect que retorna as listas.
  useEffect(() => {
    if (
      !queryParams?.empresa_cnpj ||
      !queryParams?.empresa_id ||
      !queryParams.usuario_id
    )
      return;

    getData({
      setLoading,
      empresa_cnpj: queryParams.empresa_cnpj,
      empresa_id: queryParams.empresa_id,
      usuario_id: queryParams.usuario_id,
    });
  }, [
    getData,
    queryParams.empresa_cnpj,
    queryParams.empresa_id,
    queryParams.usuario_id,
  ]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={true}
      style={{ zIndex: "998" }}
    >
      <Loading open={viewLoading} />
      <DialogTitle>
        {
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography>{`GERAÇÃO DE CONTRATOS (em lotes):`}</Typography>
            <Tooltip title="Sair para a revisão de contratos" placement="left">
              <IconButton aria-label="close" onClick={handleClose} size="small">
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        }
      </DialogTitle>

      <DialogContent style={{ minHeight: "300px", overflowX: "hidden" }}>
        {isSelectingClients ? (
          <SelectClients
            setClientList={setClientList}
            clientList={clientList}
            empresaId={queryParams.empresa_id}
            allSelected={allSelected}
            setAllSelected={setAllSelected}
            urlObjects={urlObjects}
            setUrlObjects={setUrlObjects}
          />
        ) : (
          <ReviewContract
            loading={loading}
            direction={direction}
            displayContent={displayContent}
            setDisplayContent={setDisplayContent}
            customMessage={customMessage}
            clientData={clientList[currentClientIndex]}
          />
        )}
      </DialogContent>
      <DialogActions>
        <FontButton>
          <Grid
            container={isSelectingClients ? false : true}
            spacing={2}
            justifyContent={
              !isSelectingClients ? "space-between" : "flex-start"
            }
          >
            {!isSelectingClients && !finishScreen && (
              <Grid item>
                <Btn
                  disabled={
                    currentClientIndex === 0 && currentContractIndex === 0
                  }
                  bgcolor="red"
                  hovercolor="darkred"
                  onClick={handleClickBack}
                  label="Anterior"
                />
              </Grid>
            )}
            <Grid
              container={isSelectingClients ? true : false}
              item={isSelectingClients ? false : true}
              justifyContent={isSelectingClients ? "flex-end" : "space-between"}
            >
              {isSelectingClients && (
                <Btn
                  label="INICIAR"
                  onClick={() => {
                    handleFinishSelecting({ allSelected, urlObjects });
                  }}
                  disabled={loading || disabledButton}
                  startIcon={
                    loading && (
                      <CircularLoader
                        size="15px"
                        style={{ marginRight: "15px" }}
                      />
                    )
                  }
                />
              )}
              {!isSelectingClients && !finishScreen && (
                <Tooltip
                  title="Ignora a revisão/geração do contrato atual sem interferir no mesmo e parte para o próximo."
                  placement="left"
                  arrow={true}
                >
                  <span>
                    <Btn
                      style={{ marginRight: "12px" }}
                      label={
                        <>
                          <DeleteIcon style={{ marginRight: "5px" }} />
                          {"Ignorar Cliente"}
                        </>
                      }
                      onClick={() => handleClickNext(true)}
                      bgcolor="red"
                      hovercolor="darkred"
                      disabled={
                        Array.isArray(
                          clientList[currentClientIndex]?.contratos
                        ) &&
                        clientList[currentClientIndex]?.contratos[
                          currentContractIndex
                        ]?.saved
                      }
                    />
                  </span>
                </Tooltip>
              )}
              {!isSelectingClients && !finishScreen && (
                <Btn
                  label={
                    clientList?.length === clickResponseTotal ||
                    (currentClientIndex === clientList?.length - 1 &&
                      !allSelected)
                      ? "Salvar e Finalizar"
                      : Array.isArray(
                          clientList[currentClientIndex]?.contratos
                        ) &&
                        clientList[currentClientIndex]?.contratos[
                          currentContractIndex
                        ]?.saved
                      ? "Próximo"
                      : "Salvar"
                  }
                  onClick={() => handleClickNext()}
                />
              )}
              {finishScreen && (
                <Grid container spacing={2}>
                  <Grid item>
                    <Btn
                      label="Voltar á seleção de clientes"
                      onClick={handleClickReset}
                    />
                  </Grid>
                  <Grid item>
                    <Btn
                      label="Gerenciamento de Contrato"
                      onClick={handleManagement}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </FontButton>
      </DialogActions>
    </Dialog>
  );
};

let typingTimer = null;
const SelectClients = ({
  setClientList,
  clientList,
  empresaId,
  allSelected,
  setAllSelected,
  urlObjects,
  setUrlObjects,
}) => {
  const [contractFilter, setContractFilter] = useState({
    label: "Todos",
    value: "",
  });
  const [textFilter, setTextFilter] = useState("");
  const [loadingTable, setLoadingTable] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [pagePropDefault, setPagePropDefault] = useState(0);
  const [totalItens, setTotalItens] = useState(0);

  const rowsPerPage = 10;
  const quantidadePorPesquisa = 50;

  const columns = [
    {
      id: "document",
      label: "CPF/CNPJ",
      format: (value) =>
        value?.document &&
        MaskService.toMask(
          (value?.document || "").replace(/[^0-9]+/g, "").length === 11
            ? "cpf"
            : "cnpj",
          value?.document || ""
        ),
    },
    {
      id: "clientName",
      label: "Razão",
    },
  ];

  const customHandleChangePage = async (event, page, itemIndex) => {
    setLoadingTable(true);
    let pageCarregar = Math.round(itemIndex / quantidadePorPesquisa + 1);
    let clients;

    clients = await findClientsContractsResumeV3({
      perPage: quantidadePorPesquisa,
      page: pageCarregar,
      filters: {
        contractType: urlObjects?.tipocontrato || "",
        document: urlObjects.cnpj || "",
        companyId: empresaId ?? "",
        name: encodeURIComponent((urlObjects.razao || "").toLowerCase()),
      },
    });

    setLoadingTable(false);
    return clients.data;
  };

  useEffect(() => {
    if (!contractFilter)
      setContractFilter({
        label: "Todos",
        value: "",
      });
  }, [contractFilter, setContractFilter]);

  useEffect(() => {
    const searchItems = async () => {
      setLoadingTable(true);

      const callback = await findClientsContractsResumeV3({
        perPage: quantidadePorPesquisa,
        page: 1,
        filters: {
          contractType: urlObjects?.tipocontrato || "",
          document: urlObjects.cnpj || "",
          companyId: empresaId ?? "",
          name: encodeURIComponent((urlObjects.razao || "").toLowerCase()),
        },
      });
      setSuggestions(callback.data || []);
      setTotalItens(callback.paginate?.total || 0);
      setLoadingTable(false);
    };

    searchItems();
  }, [empresaId, urlObjects.cnpj, urlObjects.razao, urlObjects?.tipocontrato]);

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      setPagePropDefault(0);
      setUrlObjects({
        tipocontrato: contractFilter?.value || "",
        cnpj: textFilter.replace(/[^0-9]/g, ""),
        razao: encodeURIComponent((textFilter || "").toLowerCase()),
        empresa_id: empresaId,
      });
    }, 1500);
  }, [contractFilter, textFilter, setUrlObjects, empresaId]);

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{ marginBottom: "8px", marginTop: "8px" }}
      >
        <Grid item md={8}>
          <TextFieldErp
            variant="filled"
            value={textFilter}
            setValue={setTextFilter}
            label="Pesquise por CPF, CNPJ ou razão social."
          />
        </Grid>
        <Grid item md={4}>
          <SelectErp
            variant="filled"
            value={contractFilter}
            setValue={setContractFilter}
            label="Tipo de contrato"
            descriptionField="label"
            optionsList={[
              {
                label: "Todos",
                value: "",
              },
              {
                label: "Contratos Recorrente",
                value: "R",
              },
              {
                label: "Contratos Avulsos",
                value: "A",
              },
              {
                label: "Sem contrato",
                value: "S",
              },
            ]}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <TableDefault
          selected={clientList}
          setSelected={setClientList}
          smallFont
          selectable
          columns={columns}
          values={suggestions}
          loading={loadingTable}
          quantidadeItensTotal={totalItens}
          rowsPerPage={rowsPerPage}
          customHandleChangePage={customHandleChangePage}
          pageProp={pagePropDefault}
          setPageProp={setPagePropDefault}
          allChecked={allSelected}
          setAllChecked={setAllSelected}
          route="prouser/clientes/v1/filtrocontratos"
          urlObjects={urlObjects}
          tableTitle=""
          maxHeight="30vh"
          selectAllOnLoad
          stickyHeader
          initialSort="razao"
        />
      </Grid>
    </>
  );
};

export const ReviewContract = ({
  displayContent = false,
  setDisplayContent = () => {},
  customMessage = "",
  clientData = null,
}) => {
  const {
    banksList,
    servicesList,
    readjustsList,
    contractTypesList,
    service,
    setService,
    readjust,
    setReadjust,
    bank,
    setBank,
    deadline,
    setDeadline,
    value,
    currentContractIndex,
    setValue,
    billType,
    setBillType,
    NFSeType,
    setNFSeType,
    vigency,
    setVigency,
    finishScreen,
    directions,
    errors,
    contractType,
    setContractType,
    keepValues,
    setKeepValues,
    competency,
    setCompetency,
    competencyExample,
    loading,
    setCompetencyExample,
    listBillet,
    setDefaultBillTypeOption,
    issueType,
    setIssueType,
    applyBillingRule,
    setApplyBillingRule,
  } = useContext(RevisaoContratoContext);

  const { setContractData, returnCompetencyAndVigency } =
    useRevisaoContratoController();

  useEffect(() => {
    if (displayContent === true) return;

    setTimeout(() => {
      setDisplayContent(true);
    }, 800);
  }, [displayContent, setDisplayContent]);

  useEffect(() => {
    // Função utilizada para recuperar os dados do contrato
    setContractData(
      Array.isArray(clientData?.contratos)
        ? clientData?.contratos[currentContractIndex]
        : null
    );
  }, [clientData, currentContractIndex, setContractData]);

  // Funções para preencher os campos casos estejam vazios.
  useEffect(() => {
    if (billType) return;

    const defaultBillType = bank?.tipo_boleto_principal || "hibrido";
    let defaultBillTypeOption = setDefaultBillTypeOption(defaultBillType);
    setBillType(defaultBillTypeOption);
  }, [billType, bank, setDefaultBillTypeOption, setBillType]);

  // Se já tiver um total setado no contrato,
  // não executa esse useEffect, pois já foi setado
  // anteriormente.
  useEffect(() => {
    if (
      !service ||
      (Array.isArray(clientData?.contratos) &&
        clientData?.contratos[currentContractIndex]?.total)
    )
      return;

    setValue(
      service?.valor ? MaskService.toMask("decimal", service?.valor) : "0.00"
    );
  }, [service, setValue, clientData?.contratos, currentContractIndex]);

  // Se já tiver um contrato, utiliza a vigência/competência do mesmo
  useEffect(() => {
    if (
      !deadline ||
      !competency ||
      (Array.isArray(clientData?.contratos) &&
        clientData?.contratos[currentContractIndex])
    )
      return;

    const { competencyExample, vigency } = returnCompetencyAndVigency({
      competency: competency.value,
      deadline,
    });

    setCompetencyExample(competencyExample);
    setVigency(vigency);
  }, [
    competency,
    setVigency,
    deadline,
    setCompetencyExample,
    returnCompetencyAndVigency,
    clientData?.contratos,
    currentContractIndex,
  ]);

  useEffect(() => {
    if (competency) return;

    setCompetency({
      label: "Competência e Vencimento no mesmo mês",
      value: "atual",
    });
  }, [competency, setCompetency]);

  const ignoredContract = Array.isArray(clientData?.contratos)
    ? clientData?.contratos[currentContractIndex]?.ignored
    : false;

  const contractAlreadySaved = Array.isArray(clientData?.contratos)
    ? clientData?.contratos[currentContractIndex]?.saved
    : false;

  const isBankCodeZero = bank?.banco?.codigo === "000";

  return (
    <Slide
      direction={displayContent ? directions[0] : directions[1]}
      in={displayContent}
    >
      {finishScreen ? (
        <FinishContainer>
          <FinishIcon>
            <CheckCircleIcon />
          </FinishIcon>
          <FinishText>Tudo certo!</FinishText>
          <FinishText subtitle>{customMessage}</FinishText>
        </FinishContainer>
      ) : (
        <CustomContainer>
          <Grid container spacing={2} style={{ marginBottom: "8px" }}>
            <Grid item md={9}>
              <StyledChip
                bgcolor="primary"
                textcolor="white"
                label={clientData?.clientName || ""}
              />
            </Grid>
            <Grid item md={3}>
              <StyledChip
                bgcolor={
                  ignoredContract
                    ? "red"
                    : contractAlreadySaved
                    ? "green"
                    : "lightgrey"
                }
                textcolor="white"
                label={
                  <HelperTooltip
                    label={
                      ignoredContract
                        ? "IGNORADO"
                        : contractAlreadySaved
                        ? "CRIADO"
                        : "NOVO CONTRATO"
                    }
                    tooltipText={
                      ignoredContract
                        ? "Esse contrato foi IGNORADO e NÃO será criado."
                        : contractAlreadySaved
                        ? "Este contrato já foi CRIADO."
                        : "Este contrato NÃO EXISTE e será criado."
                    }
                    placement="bottom"
                    tooltipStyle={{ cursor: "pointer" }}
                    tooltipColor="white"
                  />
                }
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid
              style={{ paddingTop: "5px", paddingBottom: "5px" }}
              item
              xs={12}
            >
              <Grid container justifyContent="space-between">
                <FormControlLabel
                  style={{ marginRight: "16px" }}
                  control={
                    <Checkbox
                      style={{ padding: "5px", paddingLeft: "9px" }}
                      checked={keepValues}
                      onChange={({ target: { checked } }) =>
                        setKeepValues(checked)
                      }
                    />
                  }
                  label={
                    <HelperTooltip
                      label="Manter dados para o próximo contrato"
                      tooltipText="Mantém os valores dos campos para o próximo contrato para maior agilidade na criação."
                    />
                  }
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={5}>
              <SelectErp
                label="Classificação de serviço"
                descriptionField="descricao"
                optionsList={servicesList}
                error={!!errors?.errorsValidation?.service || false}
                helperText={errors?.errorsValidation?.service || ""}
                value={service}
                setValue={setService}
                loading={loading || false}
                disabled={contractAlreadySaved}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <SelectErp
                label="Tipo de serviço"
                descriptionField="descricao"
                optionsList={contractTypesList}
                error={!!errors?.errorsValidation?.contractType || false}
                helperText={errors?.errorsValidation?.contractType || ""}
                value={contractType}
                setValue={setContractType}
                loading={loading || false}
                disabled={contractAlreadySaved}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <SelectErp
                optionsList={readjustsList}
                error={!!errors?.errorsValidation?.readjust || false}
                helperText={errors?.errorsValidation?.readjust || ""}
                value={readjust}
                setValue={setReadjust}
                loading={loading || false}
                descriptionField="descricao"
                label="Tipo de reajuste"
                disabled={contractAlreadySaved}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4}>
              <SelectErp
                label="Banco/Agência"
                optionsList={banksList}
                value={bank}
                error={!!errors?.errorsValidation?.bank || false}
                helperText={errors?.errorsValidation?.bank || ""}
                setValue={setBank}
                loading={loading || false}
                descriptionField="apelido"
                disabled={contractAlreadySaved}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <TextFieldErp
                label="Vencimento (data)"
                value={deadline}
                setValue={setDeadline}
                error={!!errors?.errorsValidation?.deadline || false}
                helperText={errors?.errorsValidation?.deadline || ""}
                type="date"
                disabled={contractAlreadySaved}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={5}>
              <SelectErp
                label="Regime de competência"
                optionsList={[
                  {
                    label: "Competência e Vencimento no mesmo mês",
                    value: "atual",
                  },
                  {
                    label: "Competência em mês anterior ao Vencimento",
                    value: "anterior",
                  },
                  {
                    label: "Competência em mês posterior ao Vencimento",
                    value: "posterior",
                  },
                ]}
                descriptionField="label"
                value={competency}
                onChange={(event) => {
                  const { competencyExample, vigency } =
                    returnCompetencyAndVigency({
                      competency: event?.value || null,
                      deadline,
                    });

                  setCompetencyExample(competencyExample);
                  setVigency(vigency);
                  setCompetency(event);
                }}
                disabled={contractAlreadySaved}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <Grid container spacing={2}>
                <Grid item xs={6} sm={6} md={6}>
                  <TextFieldErp
                    label="Competência"
                    disabled
                    variant="outlined"
                    value={competencyExample}
                  />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <TextFieldErp
                    label="Vigência (Renovação)"
                    placeholder="MM/AA"
                    value={vigency}
                    error={!!errors?.errorsValidation?.vigency || false}
                    helperText={errors?.errorsValidation?.vigency || ""}
                    setValue={setVigency}
                    disabled
                    variant="outlined"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                {isBankCodeZero && (
                  <Grid item xs={6} sm={6} md={6}>
                    <SelectErp
                      label="Tipo de boleto"
                      descriptionField="label"
                      options={listBillet}
                      value={billType}
                      setValue={setBillType}
                    />
                  </Grid>
                )}
                <Grid item xs={isBankCodeZero ? 6 : 7}>
                  <FormControlLabel
                    style={{ marginLeft: "-5px" }}
                    control={
                      <Switch
                        checked={NFSeType}
                        onChange={({ target: { checked } }) => {
                          setNFSeType(checked);
                          if (!checked) {
                            setIssueType(false);
                          } else {
                            setIssueType(true);
                          }
                        }}
                        name="checkedB"
                        color="primary"
                      />
                    }
                    label="Emitir Nota Fiscal de Serviço (NFS-e)"
                    disabled={contractAlreadySaved}
                  />
                </Grid>
                {NFSeType && (
                  <Grid item style={{ marginLeft: 30 }} xs={11}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={issueType}
                          onChange={({ target: { checked } }) => {
                            setIssueType((current) => !current);
                          }}
                          color="secondary"
                        />
                      }
                      label="Emitir no Faturamento"
                      labelPlacement="end"
                    />
                  </Grid>
                )}
                {NFSeType && (
                  <Grid item style={{ marginLeft: 30 }} xs={11}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={!issueType}
                          onChange={({ target: { checked } }) => {
                            setIssueType((current) => !current);
                          }}
                          color="secondary"
                        />
                      }
                      label="Emitir na Liquidação do Boleto"
                      labelPlacement="end"
                    />
                  </Grid>
                )}
                {/* <Grid item container xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={applyBillingRule}
                        onChange={() =>
                          setApplyBillingRule((current) => !current)
                        }
                        color="secondary"
                      />
                    }
                    label="Régua de cobrança"
                    labelPlacement="end"
                  />
                </Grid> */}
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={4} container alignItems="flex-end">
              <Tooltip title="Campo editável" arrow placement="top">
                <span>
                  <TextFieldErp
                    variant="filled"
                    className="UpdatedValue"
                    placeholder="0,00"
                    label="Valor mensal"
                    textAlignRight
                    error={!!errors?.errorsValidation?.value || false}
                    helperText={errors?.errorsValidation?.value || ""}
                    value={value}
                    setValue={setValue}
                    mask="decimal"
                    disabled={contractAlreadySaved}
                  />
                </span>
              </Tooltip>
            </Grid>
          </Grid>
        </CustomContainer>
      )}
    </Slide>
  );
};

const RevisaoContrato = ({ ...props }) => {
  return (
    <RevisaoContratoContextProvider>
      <View {...props} />
    </RevisaoContratoContextProvider>
  );
};

export default RevisaoContrato;
